import { Controller } from "@hotwired/stimulus"
import LazyLoad from "vanilla-lazyload";

export default class extends Controller {

  static targets = ['tabs', 'graphArea']

  connect() {
    window.lazyloadInstance = new LazyLoad();

    // 初期表示: DOMContentLoaded 直後はレイアウト未確定のため RAF 後に update() する
    requestAnimationFrame(() => {
      window.lazyloadInstance.update();
    });

    // もっと見る (Turbo Stream) 対応:
    // turbo:before-stream-render は DOM 更新の直前に発火し、更新は同期的に行われる。
    // RAF をスケジュールすることで DOM 更新完了後に確実に update() + loadAll() を呼べる。
    // turbo:submit-end は fetch 完了前に発火するため使用しない。
    this._onBeforeStreamRender = () => {
      requestAnimationFrame(() => {
        window.lazyloadInstance.update();
        window.lazyloadInstance.loadAll();
      });
    };
    document.addEventListener('turbo:before-stream-render', this._onBeforeStreamRender);
  }

  disconnect() {
    document.removeEventListener('turbo:before-stream-render', this._onBeforeStreamRender);
  }

  sortTable(event) {
    const sortBy = event.target.parentElement.dataset.sortBy
    const orderBy = event.target.parentElement.dataset.orderBy
    const url = new URL(window.location)
    url.searchParams.set('sort_by', sortBy)
    url.searchParams.set('order_by', orderBy)
    window.location.href = url.toString()
  }

  getIndex(el){
    return [...el.parentElement.children].indexOf(el);
  }
}
